module.exports = __webpack_public_path__ + "media/10_3.5ab90697.wav";